/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, {useEffect, useMemo, useState} from 'react'
import {treeFavEnabled, usePostRequest, useReadWriteFavorites} from "../../../../api/helper";
import {useAppSelector} from "../../../../redux/hooks";
import {selectCurrentUser} from "../../../../redux/ducks/AccessControl/slice";
import styled from "styled-components";
import ArgosFlexbox from "../../../components/Containers/ArgosFlexbox";
import {ArgosFavoriteBorderIcon, ArgosFavoriteIcon} from "../../../components/Buttons/ArgosFavoriteIcon";
import {TRACKED_ITEMS_ICONS_MAP} from "../../../../constants/trackedItems";
import ArgosButton from "../../../components/Buttons/ArgosButton";
import {TRACKED_ITEMS_ENDPOINT} from "../../../../api/constants";
import {hasRequiredProps} from "../../../../helpers/helpers";

export const StyledListItem = styled.a({
  ':hover': {
    // backgroundColor: 'lightgrey',
  },
  textDecoration: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center'
})
const INCREMENT_BY = 10
const INITIAL_ITEMS = 10

const RecentlyViewed = () => {
  const gmid = useAppSelector(state => selectCurrentUser(state).id)
  const [favorites, setFavorites] = useReadWriteFavorites()

  const fetchRecentlyViewedHandle = usePostRequest(TRACKED_ITEMS_ENDPOINT)
  const [recentlyViewedItems, setRecentlyViewedItems] = useState<any>([])
  useEffect(() => {
    if (gmid == null) return;
    const body = {
      gmid: gmid,
      requestType: 'getRecentlyViewed',
    }
    fetchRecentlyViewedHandle(body)
      .then(r => {
        setRecentlyViewedItems(r)
      }).catch((e) => {
      console.error(e)
    })
  }, [gmid])

  const filteredRecentlyViewedItems = useMemo(() => {
    return recentlyViewedItems?.filter((item: any) => {
      const setRequiredProps = new Set(['url', 'trackedItemUid', 'type', 'label']);
      return hasRequiredProps(item, setRequiredProps)
    })
  }, [recentlyViewedItems])

  const setfav = (id: string, enabled: boolean, trackedItemType: string, partitionKey: string | undefined = undefined) => {
    const favoriteMethod = enabled ? 'DELETE' : 'POST'
    setFavorites({type: trackedItemType, id: id, partitionKey}, favoriteMethod)
  }

  const [displayedItems, setDisplayedItems] = useState<number>(INITIAL_ITEMS)
  const _onLoadMore = () => {
    setDisplayedItems(displayedItems + INCREMENT_BY)
  }

  return (
    <ArgosFlexbox rowGap={0} vertical style={{marginTop: 0, overflow: 'auto', height: '100%'}}>
      <div style={{overflow: 'auto', flex: 1}}>
        {filteredRecentlyViewedItems?.slice(0, displayedItems)?.map((item: any, i: number) => {
          const url = item?.url
          const favid = item?.trackedItemUid
          const _isFavEnabledd = treeFavEnabled(favorites, favid)
          const tracked_item_type = item?.type
          const _onclick = () => {
            setfav(favid, _isFavEnabledd, tracked_item_type, item?.partitionKey)
          }
          const bookmarkIcon = -_isFavEnabledd ? <ArgosFavoriteIcon onClick={_onclick}/>
            : <ArgosFavoriteBorderIcon onClick={_onclick}/>
          const icon = TRACKED_ITEMS_ICONS_MAP?.[item?.type] ?? null
          return (
            <ArgosFlexbox
              key={i} style={{justifyContent: "space-between", borderBottom: '1px solid lightgrey'}}>
              <StyledListItem
                onClick={(e) => {
                  window.open(url, '_blank')
                }}
                data-no-dnd="true"
                style={{gap: 5}}
              >
                <span>{icon}</span>
                <span>{item?.label}</span>
              </StyledListItem>
              <span data-no-dnd={"true"}>
                {bookmarkIcon}
              </span>
            </ArgosFlexbox>
          )
        })}
      </div>
      <ArgosButton data-no-dnd="true" disabled={displayedItems >= filteredRecentlyViewedItems?.length || filteredRecentlyViewedItems?.length === 0}
                   style={{alignSelf: 'center', marginTop: 5}}
                   onClick={() => _onLoadMore()}>Load More</ArgosButton>
    </ArgosFlexbox>
  )
}
export default RecentlyViewed